import React, { useEffect, useState } from 'react';

import cloneDeep from 'lodash/cloneDeep';
import { AxiosError } from 'axios';
// eslint-disable-next-line import/order
import { History, LocationState } from 'history';
// eslint-disable-next-line import/order
import { connect } from 'react-redux';
import '../styles/containers/Activity.css';

import { useLocation, useParams } from 'react-router-dom';

import Modal from '../components/utils/ModalComponet';
import Error from '../components/stateMessage/Error';
import Spinner from '../components/utils/Spinner';
import { setFilterData, setFilterFlag } from '../actions/activitiesActions';
import { isMobileResolution } from '../infrastructure/utils/common';
import ActivityView from '../components/activities/ActivityView/ActivityView';
import TopPanel from '../components/utils/TopPanel';
import ActivityOrdersList from '../components/orders/ActivityOrdersList';
import * as Service from '../services/ActivitiesService';
import * as RnrsService from '../services/RnrsService';
import {
  deleteReviewResponse,
  updateReviewResponse,
} from '../services/RnrsService';
import * as VendorsService from '../services/VendorsService';
import TableSortingElem from '../infrastructure/TableSorting';
import * as OrderService from '../services/OrdersService';
import ActivityFAQFormSection from '../components/activities/ActivityFAQFormSection';
import { BookingOptionList } from '../components/activities/BookingOptionList/BookingOptionList';
import ActivitiesRnR from '../components/activities/ActivitiesRnR/ActivitiesRnR';
import ActivityMetaFields from '../components/activities/ActivityMetaFields/ActivityMetafields';
import ActivityTagFields from '../components/activities/ActivityTagFields/ActivityTagFields';
import ActivitySourceFields from '../components/activities/ActivitySourceFields/ActivitySourceFields';
import ActivityPopularityMobile from '../components/activities/ActivityPopularityMobile';
import ActivityVendorMobile from '../components/activities/AcitivityVendorMobile';
import CollapsableItem from '../components/utils/CollapsableItem';
import ActivityVendorView from '../components/activities/ActivityView/ActivityVendorView';
import ReviewResponseModal from '../components/rnrs/ReviewResponseModal';
import { Vendor } from '../types/Vendor';
import ActivityAttachments from '../components/activities/ActivityAttachments';
import {
  getIsNotIntegrationEnabled,
  isFareharborSource,
} from '../components/forms/EditPeekAndRedeamOrderForm/helpers';
import BookingOptionModal from '../components/activities/ActivityModals/BookingOptionContent/components/BookingOptionModal';
import { Order } from '../types/Order';
import { getActivityActions } from '../infrastructure/constants/activities';
import { Activity, ActivitySource, BookingOption } from '../types/Activity';
import { ProductReview } from '../types/ProductReview';
import AlertWrapper from '../components/utils/AlertWrapper';
import * as PartyService from '../services/PartiesService';
import { PartyType } from '../types/Party';
import { ActivityContext } from '../contexts/Activity';
import CapabilitiesSection from '../components/activities/CapabilitiesSection';
import type { ActivityItem } from '../components/utils/AutoComplete/ActivitiesAutoComplete';
import ActivityBookingNotesFormSection from '../components/activities/ActivityBookingNotesFormSection';
import { getConfig } from '../config';

type Props = {
  history: History<LocationState>;
  setFilter(data: unknown): void;
  activateFilter(value: boolean): void;
};

const tryToFindVendor = async (id: string): Promise<Vendor | null> => {
  try {
    return await VendorsService.fetchVendorById(id);
  } catch (e) {
    const error = e as AxiosError;
    alert(
      `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
    );
    console.error('[get vendor] %j', { id });
    console.error(e);
    return null;
  }
};

const ActivityPage = ({
  history,
  setFilter,
  activateFilter: setActivateFilter,
}: Props) => {
  const { goBack } = history;

  const [deactive, setDeactive] = useState<boolean>(false);
  const [activity, setActivity] = useState<Activity | null>(null);
  const [suggestedActivity, setSuggestedActivity] = useState<ActivityItem>();
  const [backpage, setBackpage] = useState<boolean>(false);
  const [avaliableSort, setAvaliableSort] = useState<TableSortingElem[]>([]);
  const [activeSort, setActiveSort] = useState<TableSortingElem | null>(null);
  const [rnrs, setRnrs] = useState([]);
  const [sendingStatus, setSendingStatus] = useState<boolean>(false);
  const [
    isCreateBookingOptionOpen,
    setIsCreateBookingOptionOpen,
  ] = useState<boolean>(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [
    bookingOptionToEdit,
    setBookingOptionToEdit,
  ] = useState<BookingOption | null>(null);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [dataSource, setDataSource] = useState(null);
  const [bookingOptionOrder, setBookingOptionOrder] = useState<BookingOption[]>(
    []
  );
  const [vendor, setVendor] = useState<Vendor | null>(null);
  const [orders, setOrders] = useState<Order[]>([]);
  const [allTags, setAllTags] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [
    reviewToResponse,
    setReviewToResponse,
  ] = useState<ProductReview | null>(null);
  const [copyAlert, setCopyAlert] = useState<string>('');

  const [isFareharborActivity, setIsFareharborActivity] = useState<boolean>(
    false
  );
  const [canAddBookingOptions, setCanAddBookingOptions] = useState<boolean>(
    true
  );
  const [partyTypes, setPartyTypes] = useState<PartyType[]>([]);
  const params = useParams();
  const location = useLocation();

  const handleBookingOptionEditRoute = (bookingOptions: BookingOption[]) => {
    if (!params.optionId) return;

    setBookingOptionToEdit(
      bookingOptions.find(option => option.id === params.optionId) || null
    );
  };

  useEffect(() => {
    let ignore = false;
    const init = async () => {
      try {
        if (history.length > 2) {
          setBackpage(true);
        }

        if (location.state?.skipReload) {
          window.history.replaceState({}, '');
          handleBookingOptionEditRoute(bookingOptionOrder);
          return;
        }

        const [
          activity,
          suggestedActivityItem,
          tags,
          orders,
          rnrs,
          partyTypes,
        ] = await Promise.all([
          Service.getById(params.id),
          Service.getSuggestedActivity(params.id),
          Service.getAllTags(),
          OrderService.getOrdersByActivity(
            params.id,
            new TableSortingElem({ name: 'totalPrice', isString: true })
          ),
          Service.getRnRsByActivityId(params.id),
          PartyService.listActivePartyTypes(),
        ]);
        const { vendorId, tags: activityTags = [], bookingOptions = [] } =
          activity ?? {};
        const vendor = await tryToFindVendor(vendorId);

        const suggestedActivity = suggestedActivityItem.activity && {
          id: suggestedActivityItem.activity.id,
          title: suggestedActivityItem.activity.title,
          city: suggestedActivityItem.activity.city,
        };

        if (!deactive && !ignore) {
          setRnrs(rnrs);
          setActivity(activity);
          setVendor(vendor);
          setSelectedTags(activityTags);
          setBookingOptionOrder(bookingOptions);
          setOrders(orders);
          setAllTags(tags.map(tag => tag.name));
          setAvaliableSort([
            new TableSortingElem({ name: 'totalPrice', isString: true }),
            new TableSortingElem({ name: 'status', isString: true }),
            new TableSortingElem({ name: 'created' }),
          ]);
          setActiveSort(
            new TableSortingElem({
              name: 'totalPrice',
              isString: true,
            })
          );
          setPartyTypes(partyTypes);
          setSuggestedActivity(suggestedActivity);

          handleBookingOptionEditRoute(bookingOptions);
        }
      } catch (e) {
        const error = e as AxiosError;
        alert(
          `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
        );
        console.log(error.message);
      }
    };
    init();
    return () => {
      ignore = true;
    };
  }, [deactive, history.length, history.location.pathname]);

  useEffect(() => {
    return () => {
      if (history.location.pathname !== '/activities') {
        setActivateFilter(false);
        setFilter(undefined);
      }
      setDeactive(false);
    };
  }, [history.location.pathname, setActivateFilter, setFilter]);

  useEffect(() => {
    const isFromFareharbor = activity?.source === ActivitySource.fareharbor;
    const isFromPeekOrRedeam =
      activity?.source === ActivitySource.peek ||
      activity?.source === ActivitySource.redeam ||
      activity?.source === ActivitySource.singenuity;
    setIsFareharborActivity(isFromFareharbor);
    setCanAddBookingOptions(!isFareharborActivity && !isFromPeekOrRedeam);
  }, [activity]);

  useEffect(() => {
    if (copyAlert) {
      setTimeout(() => {
        setCopyAlert('');
      }, 2500);
    }
  }, [copyAlert]);

  const {
    id: activityId,
    source,
    bookingOptions: activityBookingOptions = [],
    tags = [],
    meta,
    metadata,
  } = activity ?? {};

  const onOrderClick = (order: Order) => history.push(order);

  const changeSort = async (name: string) => {
    if (!activeSort) return;
    let sort: TableSortingElem | undefined;
    if (activeSort.name === name) {
      sort = {
        ...activeSort,
        up: !activeSort.up,
      };
    } else {
      const newSort = avaliableSort.find(s => s.name === name);
      if (newSort) {
        sort = newSort;
      }
    }
    if (sort) {
      setActiveSort(sort);
    }
    const orders = await OrderService.getOrdersByActivity(activityId, sort);
    setOrders(orders);
  };
  const hideMessage = () => setErrorMessage(null);

  const onHandleError = e => {
    const error = e as AxiosError;
    setErrorMessage(
      `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
    );
    setTimeout(hideMessage, 5000);
  };

  const toDelete = async () => {
    try {
      await Service.deleteActivity(activityId);
      history.push('/activities');
    } catch (e) {
      onHandleError(e);
    } finally {
      setIsOpenDeleteModal(false);
    }
  };

  const onDelete = () => setIsOpenDeleteModal(true);

  const setRnrsWithModified = modified => {
    const copy = cloneDeep(rnrs);
    const index = copy.findIndex(
      c => c.productId === modified.productId && c.userId === modified.userId
    );
    if (index === -1) return;
    copy[index] = modified;
    setRnrs(copy);
  };

  const onFeaturedChange = async item => {
    try {
      setSendingStatus(true);
      await RnrsService.updateRnRFeaturedStatus(item);
      const copy = cloneDeep(item);
      copy.featured = !copy.featured;
      setRnrsWithModified(copy);
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
    }
  };

  const onResponseSend = async (response, reviewToResponse) => {
    try {
      setSendingStatus(true);
      setReviewToResponse(null);
      let modified;
      if (reviewToResponse.adminResponse) {
        modified = await updateReviewResponse(
          reviewToResponse.productId,
          reviewToResponse.userId,
          response
        );
      } else {
        modified = await RnrsService.createReviewResponse(
          reviewToResponse.productId,
          reviewToResponse.userId,
          response
        );
      }
      setRnrsWithModified(modified);
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
    }
  };

  const onResponseDelete = async reviewToResponse => {
    try {
      setSendingStatus(true);
      setReviewToResponse(null);
      const modified = await deleteReviewResponse(undefined, reviewToResponse);
      setRnrsWithModified(modified);
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
    }
  };

  const changeReviewVisibility = async review => {
    try {
      setSendingStatus(true);
      const hidden = !review.hidden;
      const { productId, userId } = review;
      const modified = await RnrsService.changeReviewVisibility(
        productId,
        userId,
        hidden
      );
      setRnrsWithModified({ ...review, ...modified });
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
    }
  };

  const onUserIdClick = (id: string) => history.push(`/users/${id}`);

  const updateActivity = async (
    fields: Partial<Activity>
  ): Promise<Activity | undefined> => {
    setSendingStatus(true);
    try {
      const result = await Service.updateActivity(activityId, fields);
      const { bookingOptions = [] } = result ?? {};
      setActivity(result);
      setBookingOptionOrder(bookingOptions);
      return result;
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
    }
  };

  const bookingOptionSubmitHandle = async (
    id: string,
    option: BookingOption
  ) => {
    setSendingStatus(true);
    try {
      const updatedActivity = await Service.updateActivity(activityId, {
        bookingOptions: bookingOptionOrder.map(opt => {
          if (opt.id === id) return option;

          return opt;
        }),
      });

      const { bookingOptions = [] } = updatedActivity ?? {};
      setActivity(updatedActivity);
      setBookingOptionOrder(bookingOptions);
      setBookingOptionToEdit(null);
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
    }
  };

  const onReorderBookingOptions = ({ newBookingOptionOrder }) => {
    setBookingOptionOrder(newBookingOptionOrder);
  };

  const deleteBookingOption = async (optionId: string) => {
    setSendingStatus(true);
    try {
      await Service.deleteBookingOption(activityId, optionId);
      const newActivity = await Service.getById(activityId);
      const { bookingOptions = [] } = newActivity;
      if (!bookingOptions.length) {
        const filteredTags = tags.filter(item => item !== 'bookable');
        setSelectedTags(filteredTags);
        const result = await Service.updateActivity(activityId, {
          tags: filteredTags,
        });
        newActivity.tags = result.tags;
      }

      setActivity(newActivity);
      setBookingOptionOrder(bookingOptions);
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
      setBookingOptionToEdit(null);
    }
  };

  const createBookingOption = async (option: BookingOption) => {
    setSendingStatus(true);
    try {
      const updatedActivity = await Service.updateActivity(activityId, {
        bookingOptions: [...bookingOptionOrder, option],
      });

      const { bookingOptions = [] } = updatedActivity;
      setActivity(updatedActivity);
      setBookingOptionOrder(bookingOptions);
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
      setIsCreateBookingOptionOpen(false);
    }
  };

  const onCloseBookingOptionModal = () => {
    if (selectedTags.includes('bookable') && !tags.includes('bookable')) {
      setSelectedTags(selectedTags.filter(t => t !== 'bookable'));
    }
    setIsCreateBookingOptionOpen(false);
  };

  const dataImport = async () => {
    if (dataSource) {
      setDataSource(null);
      return;
    }
    try {
      setSendingStatus(true);
      const result = await Service.getSourceById(activityId);
      setDataSource(result);
    } catch (e) {
      onHandleError(e);
    } finally {
      setSendingStatus(false);
    }
  };

  const handleBookingOptionEdit = (option: BookingOption) => {
    history.push(`/activities/${activityId}/options/${option.id}/edit`, {
      skipReload: true,
    });
    setBookingOptionToEdit(option);
  };

  const closeBookingOptionEditModal = () => {
    setBookingOptionToEdit(null);
    history.push(`/activities/${activityId}`, {
      skipReload: true,
    });
  };

  const { stripeConnectedAccounts = [] } = vendor ?? {};

  const loaded = activity != null;
  const isExpanded = !isMobileResolution();

  const config = getConfig();

  if (!loaded) {
    return <Spinner />;
  }

  return (
    <ActivityContext.Provider
      value={{
        source,
        id: activityId,
        vendor: vendor || undefined,
        bookingOptions: bookingOptionOrder,
      }}
    >
      <AlertWrapper show={!!copyAlert}>
        <p>{copyAlert}</p>
      </AlertWrapper>
      {sendingStatus && (
        <div className='sending-status-loader'>
          <Spinner />
        </div>
      )}
      {reviewToResponse && (
        <ReviewResponseModal
          isOpen={reviewToResponse}
          closeModal={() => setReviewToResponse(null)}
          onSave={onResponseSend}
          reviewToResponse={reviewToResponse}
          onResponseDelete={onResponseDelete}
        />
      )}
      {isCreateBookingOptionOpen && (
        <BookingOptionModal
          isNotIntegrationEnabled={getIsNotIntegrationEnabled(source)}
          isFareharborSource={isFareharborActivity}
          isOpen={isCreateBookingOptionOpen}
          closeModal={onCloseBookingOptionModal}
          createBookingOption={createBookingOption}
        />
      )}
      {!!bookingOptionToEdit && (
        <BookingOptionModal
          option={{ ...bookingOptionToEdit }}
          isNotIntegrationEnabled={getIsNotIntegrationEnabled(source)}
          onCancel={closeBookingOptionEditModal}
          closeModal={closeBookingOptionEditModal}
          bookingOptionSubmitHandle={bookingOptionSubmitHandle}
          onDelete={() => deleteBookingOption(bookingOptionToEdit.id)}
          isLastBookingOption={activityBookingOptions.length === 1}
        />
      )}
      <Modal
        open={isOpenDeleteModal}
        closeModal={() => {
          setIsOpenDeleteModal(false);
        }}
        action={toDelete}
        actionButtonText={'Delete'}
      >
        <div style={{ marginBottom: '40px' }}>
          Are you sure you want to delete this experience? <br />
          Do not delete if there are any orders or itinerary events for this
          experience.
        </div>
      </Modal>
      {!!errorMessage && <Error text={errorMessage} />}
      <TopPanel isDetailsPage>
        <div
          className='btn-nav back'
          style={{ marginLeft: '15px' }}
          onClick={() => {
            if (backpage) goBack();
          }}
          aria-label='left Align'
        >
          {backpage && (
            <>
              <i
                className='fas fa-arrow-left'
                style={{ paddingRight: '8px' }}
              />
              <span className='page-back'>Back</span>
            </>
          )}
          <span className='page-back-mobile'>{activity.title}</span>
        </div>
        <div className='page-actions'>
          {isFareharborActivity && (
            <button
              type='button'
              onClick={dataImport}
              className='btn btn-primary pull-right'
            >
              {dataSource ? 'Original Data' : 'Data Import'}
            </button>
          )}
          <button
            type='button'
            onClick={onDelete}
            className='btn btn-dang pull-right'
          >
            Delete Experience
          </button>
          <a
            href={`${config.batchAdminURL}/experiences/${activity.id}`}
            className='btn'
          >
            View in Admin
          </a>
        </div>
      </TopPanel>
      {dataSource ? (
        <ActivityVendorView dataSource={dataSource} />
      ) : (
        <div className='data-container'>
          <div className='data-box'>
            <ActivityView
              activity={activity}
              back={goBack}
              actions={getActivityActions(activity)}
              setCopyAlert={setCopyAlert}
              updateActivity={updateActivity}
              isFareHarbor={isFareharborActivity}
            />
          </div>
          <ActivityPopularityMobile activity={activity} />
          <ActivityVendorMobile activity={activity} />
          <ActivityAttachments activity={activity} />

          <ActivityMetaFields
            activity={activity}
            suggestedActivity={suggestedActivity}
            updateActivity={updateActivity}
            partyTypes={partyTypes}
          />

          <ActivityTagFields
            tags={tags}
            allTags={allTags}
            updateActivity={updateActivity}
            setIsBookingOptionModalOpen={() =>
              setIsCreateBookingOptionOpen(true)
            }
            originalActivity={activity}
            selectedTags={selectedTags}
            setSelectedTags={(newTags: string[]) => setSelectedTags(newTags)}
            disabled={!isFareharborSource(activity?.source)}
          />
          <ActivitySourceFields
            activity={activity}
            vendor={vendor}
            updateActivity={updateActivity}
            disabled={!isFareharborSource(activity?.source)}
          />
          <CapabilitiesSection
            onSave={updateActivity}
            meta={meta}
            metadata={metadata}
            stripeConnectedAccounts={stripeConnectedAccounts}
            disabled={!isFareharborSource(activity?.source)}
          />
          <div className='data-box'>
            <h4 className='header'>Booking Options</h4>
            {canAddBookingOptions && (
              <button
                type='button'
                className='btn btn-def'
                onClick={() => setIsCreateBookingOptionOpen(true)}
              >
                + Add Booking Option
              </button>
            )}
            {!!bookingOptionOrder.length && (
              <CollapsableItem isExpanded={isExpanded}>
                <BookingOptionList
                  content={bookingOptionOrder}
                  onBookingOptionEdit={handleBookingOptionEdit}
                  onReorderBookingOptions={onReorderBookingOptions}
                  updateActivity={updateActivity}
                />
              </CollapsableItem>
            )}
          </div>
          <ActivityFAQFormSection
            faqContent={activity.faqContent}
            isMobile={!isExpanded}
            updateActivity={updateActivity}
          />
          <ActivityBookingNotesFormSection
            bookingNotes={activity.bookingNotes}
            isMobile={!isExpanded}
            updateActivity={updateActivity}
          />
          {!!rnrs.length && (
            <div className='data-box'>
              <h4 className='header'>Ratings and Reviews</h4>
              <CollapsableItem isExpanded={isExpanded}>
                <ActivitiesRnR
                  content={rnrs}
                  onFeaturedChange={onFeaturedChange}
                  onUserIdClick={onUserIdClick}
                  setReviewToResponse={review => setReviewToResponse(review)}
                  setReviewToChangeVisibility={review =>
                    changeReviewVisibility(review)
                  }
                />
              </CollapsableItem>
            </div>
          )}
          {!!orders.length && (
            <div className='data-box'>
              <h4 className='header'>Orders</h4>
              <CollapsableItem isExpanded={isExpanded}>
                <ActivityOrdersList
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  orders={orders}
                  changeSort={changeSort}
                  activeSort={activeSort}
                  options={activityBookingOptions}
                  handleOnClick={onOrderClick}
                />
              </CollapsableItem>
            </div>
          )}
          <div className='page-actions-mobile'>
            <button
              type='button'
              onClick={onDelete}
              className='btn btn-dang pull-right'
            >
              Delete Activity
            </button>
          </div>
        </div>
      )}
    </ActivityContext.Provider>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    setFilter: data => dispatch(setFilterData(data)),
    activateFilter: data => dispatch(setFilterFlag(data)),
  };
};

export default connect(null, mapDispatchToProps)(ActivityPage);
